import { Component, Input, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Config } from "src/app/config";
import { whatsappEndpoint } from "src/app/functions/whatsapp";

@Component({
	selector: "callus",
	templateUrl: "./callus.navbar.html",
	styleUrls: ["./callus.navbar.scss"],
})
export class CallusNavbar implements OnInit {
	@Input() internalPage = false;

	@Input() border = false;

	public phone: string = `${Config.contact.prefix} ${Config.contact.phone}`;

	public phoneLink: string;

	constructor(private readonly Translate: TranslateService) {}

	ngOnInit() {
		this.phoneLink = whatsappEndpoint(this.getPhoneLink(), this.Translate.instant("whatsapp.message"));
	}

	/** Parsea el numero de telefono */
	public getPhoneLink() {
		return this.phone.replace(/-/g, "").replace(/ /g, "");
	}
}
